<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
	        <span class="search_span_width" style="width:200px">
	            <span class="search_span_width_part1">用户：</span>
              <Select
                  filterable
                  v-model="search.user_id"
                  :remote-method="userlist"
                  style="width:200px"
                  >
                  <Option  v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.mobile ? option.mobile : option.email}}</Option>
              </Select>
	        </span>
          <span class="search_span_width" style="width:200px">
              <span class="search_span_width_part1">人物ID：</span>
              <Input v-model="search.figure_id" placeholder="请输入人物Id" clearable :style="{'width':'110px'}"></Input>
          </span>
          <span class="search_span_width" style="width:200px">
              <span class="search_span_width_part1">声音ID：</span>
              <Input v-model="search.spk_id" placeholder="请输入人物Id" clearable :style="{'width':'110px'}"></Input>
          </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="studio_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="pageSize" :show-elevator="true" @on-change="getList"/>
        </Card>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      search : {
        user_id:'',
        figure_id:'',
        spk_id:''
      },
      channel_list:[],
      user_list:[],
      showmodal:false,
      showtemplatemodal:false,
      studio_list:[],
      recordTotal:0,
      page:1,
      pageSize: 10,
      option_user_id:[],
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center' },
        { title: '用户名', key: 'recharge_type', align: 'center',render:(h,params) =>{
            return h('span',{},params.row.user_info.nickname);
          } },
        { title: '用户ID', key: 'recharge_type', align: 'center',render:(h,params) =>{
            return h('span',{},params.row.user_info.id);
          } },
        { title: '人物ID', key: 'figure_id', align: 'center' },
        { title: '发音人ID', key: 'spk_id', align: 'center' },
        { title: '创建时间', key: 'created_at', align: 'center' },
      ],
    }
  },
  mounted:function(){
    this.getList(1)
  },
  computed:{

  },
  methods:{
    getList(page=this.page) {
      this.page = page;
      let p = {'page' : page, 'pageSize': this.pageSize};
      let params = Object.assign(this.search, p);
      this.http.get('/admin/knowledge/getList',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.studio_list = data.data.list;
          this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    userlist(query){
      if (query !== '') {
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;

          this.http.get('/admin/user/userList',{params:{mobile:query}}).then(response=>{
            let data=response.data;
            if(data.code!==0)
            {
              alert(data.message);
            } else{
              this.user_list = data.data.list;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });

        }, 200);
      }
    },
  }

}
</script>
